<template>
  <WdsAlert warning :title="$t('Note')">
    <template #description>
      <p>
        When taking jobs where you may be regarded as an Agency Worker, you cannot be contracted
        through your sole trader business.
      </p>
      <p>
        You can optionally be paid as PAYE from Worksome (see below) or use an umbrella service.
      </p>
    </template>
  </WdsAlert>
</template>

<script>
import { WdsAlert } from '@worksome/wds-components'

export default {
  components: {
    WdsAlert,
  },
}
</script>
